<!-- <img class="imployee-icon" src="assets/employee/employees_icon.png" alt="Role Switcher"> -->

<div *ngIf="modules.length > 1">
  <select class="employeeCategory" id="employees" name="employees" (change)="onModuleChanges($event.target.value)"
    [(ngModel)]="selectedModuleId">
    <option *ngFor="let role of modules" [value]="role.id">
      {{ role.name }}
    </option>
  </select>
</div>